export default "__VITE_ASSET__BOUDW0po__"